export const environment = {
  production: true,
  froalaKey: "Ne2C1sE4C3C3A13C11C7jF-11ykH-8klC-22D5zdtabpliitA1A1A1F1H4A1A1B1C7C5==",
  apiBaseUrl: 'https://ipj-api.harappa.education/api/v1/',
  // apiBaseUrl: 'https://ipj-lrn-dev-api.harappa.education/api/v1/',
  // apiBaseUrl: 'http://172.16.12.140:8082/api/v1/',
  partnerApiBaseUrl: 'https://prod-authoring-partner-api.harappa.education/partner/v2/',
  basePath : 'https://ipj-api.harappa.education',
  businessDomain: 'https://business.harappa.education',
  mainDomain: 'https://app.harappa.education',
  webUrl: 'https://ipj.harappa.education',
  GOOGLE_RECAPTCHA_SITEKEY:'6LfGVPIUAAAAAFx0iwWu-j9Sf6e0h-G_3Qjr9B0m'
};
